import type { SVGProps } from "react";
export interface CartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.995 2.875a3.127 3.127 0 0 1 3.124 3.24l-.034.352-.906 6a3.125 3.125 0 0 1-3.09 2.659H6.25a1.125 1.125 0 0 1 0-2.25h12.84c.432 0 .8-.317.865-.745l.905-6 .008-.196a.876.876 0 0 0-.873-.81H4.375a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M18.5 21.128a.62.62 0 0 0-.125.372l.012.126a.6.6 0 0 0 .113.245zm1 .743a.6.6 0 0 0 .112-.245l.013-.126-.013-.126a.6.6 0 0 0-.111-.246zm-10.888-.497a.6.6 0 0 0-.112-.247v.745a.6.6 0 0 0 .112-.246l.013-.126zM7.5 21.127a.62.62 0 0 0-.125.373l.013.126a.6.6 0 0 0 .112.246zM2.34.875a3.125 3.125 0 0 1 3.072 2.549l2.235 11.922c.167.887.94 1.53 1.843 1.53H20l.116.005a1.125 1.125 0 0 1 0 2.239l-.116.005H9.49a4.126 4.126 0 0 1-4.055-3.364L3.2 3.838a.875.875 0 0 0-.86-.713H2a1.125 1.125 0 0 1 0-2.25zM9.625 21.5a1.624 1.624 0 0 1-3.242.166l-.008-.166.008-.166A1.625 1.625 0 0 1 8 19.875l.166.008c.82.083 1.459.775 1.459 1.617m11 0a1.625 1.625 0 0 1-3.241.166l-.009-.166.009-.166A1.624 1.624 0 0 1 19 19.875l.166.008c.82.083 1.46.776 1.46 1.617Z"
      />
    </svg>
  );
}
